import React, { useEffect, useRef, useState, useMemo } from 'react';
import SkillSelector from '../../components/features/SkillSelector';
import PlatformSelector from '../../components/features/PlatformSelector';
import ImageUploadBox from '../../components/common/ImageUploadBox';
import { SKILL_CATEGORIES } from '../../services/skillService';
import ContentPreviewModal from '../../components/modals/ContentPreviewModal';
import { ChevronDown, Loader2 } from 'lucide-react';

const curatedPosts = [
  {
    id: 'xhs-1',
    image: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=900&q=80',
    title: '7天素颜底妆打卡',
    desc: '黄皮通勤妆容合集，5分钟出门也能看起来气色很好。',
    author: '蜜桃乌龙酱',
    content: '早八通勤人请直接抄作业：粉底只上半张脸，另一半用气垫过渡，最后薄扫杏色腮红。全程轻薄不假面，办公室灯光下也不显脏。\n\n适合黄一白到黄二白，鼻翼和嘴角用小号遮瑕刷点压，妆感会更干净。\n\n#通勤妆容 #黄皮显白 #素颜感底妆',
    images: [
      'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=900&q=80',
      'https://images.unsplash.com/photo-1526045431048-f857369baa09?w=900&q=80',
      'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=900&q=80',
    ],
  },
  {
    id: 'xhs-2',
    image: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=900&q=80',
    title: '一周减脂午餐盒',
    desc: '600kcal内搭配模板，打工人也能稳定执行的轻食计划。',
    author: '吃不胖研究所',
    content: '分享我本周最稳的午餐盒公式：主食拳头大小 + 双份蔬菜 + 掌心蛋白质。\n\n周一到周五都按这个思路配，外卖也能套模板，饱腹感和体重都更稳定。\n\n#减脂饮食 #午餐便当 #健康生活',
    images: [
      'https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=900&q=80',
      'https://images.unsplash.com/photo-1482049016688-2d3e1b311543?w=900&q=80',
      'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=900&q=80',
    ],
  },
  {
    id: 'xhs-3',
    image: 'https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=900&q=80',
    title: 'AI副业工具流',
    desc: '从选题到封面图的一整套工作流，个人号也能高频更新。',
    author: '阿宁的效率实验室',
    content: '把最近在用的 AI 内容生产流梳理成 4 步：选题库、结构化提纲、正文润色、封面统一模板。\n\n核心是把每一步做成可复用 SOP，不要每次从零开始。\n\n#AI工具 #内容创作 #副业增长',
    images: [
      'https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=900&q=80',
      'https://images.unsplash.com/photo-1515879218367-8466d910aaa4?w=900&q=80',
      'https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=900&q=80',
    ],
  },
  {
    id: 'xhs-4',
    image: 'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?w=900&q=80',
    title: '周末城市慢逛路线',
    desc: '半天可走完的拍照路线，咖啡店和展览点位都整理好了。',
    author: 'CityWalk小周',
    content: '这条 CityWalk 真的适合新手：地铁直达，整体 4 公里，沿路有 3 个可出片点位。\n\n建议下午 4 点后出发，逆光拍人像更柔和。\n\n#城市漫步 #周末去哪儿 #出片路线',
    images: [
      'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?w=900&q=80',
      'https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?w=900&q=80',
      'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=900&q=80',
    ],
  },
  {
    id: 'xhs-5',
    image: 'https://images.unsplash.com/photo-1518717758536-85ae29035b6d?w=900&q=80',
    title: '租房改造低预算',
    desc: '300 元以内把卧室氛围拉满，清单和尺寸都可直接抄。',
    author: '木子小窝',
    content: '租房党也能做氛围改造：先统一色温，再用布艺和地毯做层次，最后补一个角落灯。\n\n预算低但变化非常大，拍照也更高级。\n\n#租房改造 #卧室布置 #低预算家居',
    images: [
      'https://images.unsplash.com/photo-1518717758536-85ae29035b6d?w=900&q=80',
      'https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=900&q=80',
      'https://images.unsplash.com/photo-1484101403633-562f891dc89a?w=900&q=80',
    ],
  },
  {
    id: 'xhs-6',
    image: 'https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?w=900&q=80',
    title: '年度回购护肤单',
    desc: '敏感肌真实空瓶记录，按晨间/晚间完整拆解使用顺序。',
    author: 'Mia护肤笔记',
    content: '把我今年真空瓶的产品按「保湿、修护、提亮」分组了，敏感期也能用。\n\n顺序比单品更重要：先舒缓再叠加功效，皮肤稳定很多。\n\n#护肤空瓶 #敏感肌 #护肤流程',
    images: [
      'https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?w=900&q=80',
      'https://images.unsplash.com/photo-1556228720-195a672e8a03?w=900&q=80',
      'https://images.unsplash.com/photo-1620916566398-39f1143ab7be?w=900&q=80',
    ],
  },
  {
    id: 'xhs-7',
    image: 'https://images.unsplash.com/photo-1517849845537-4d257902454a?w=900&q=80',
    title: '宠物拍照姿势模板',
    desc: '室内低光也能拍清楚，三步出片的构图方式合集。',
    author: '毛球摄影记',
    content: '宠物拍照别急着按快门，先让它看向你手里的零食，再连拍抓动态。\n\n手机人像模式 + 侧逆光，毛发会很有层次。\n\n#萌宠日常 #宠物拍照 #手机摄影',
    images: [
      'https://images.unsplash.com/photo-1517849845537-4d257902454a?w=900&q=80',
      'https://images.unsplash.com/photo-1548199973-03cce0bbc87b?w=900&q=80',
      'https://images.unsplash.com/photo-1517423440428-a5a00ad493e8?w=900&q=80',
    ],
  },
  {
    id: 'xhs-8',
    image: 'https://images.unsplash.com/photo-1498837167922-ddd27525d352?w=900&q=80',
    title: '快手早餐备餐法',
    desc: '3 组万能搭配，早上 10 分钟内搞定营养早餐。',
    author: '早起星人Vicky',
    content: '忙碌工作日建议固定 3 套早餐模板：酸奶碗、全麦三明治、燕麦杯。\n\n前一晚准备 80%，早上只需要 10 分钟，连续执行无压力。\n\n#早餐打卡 #上班族饮食 #备餐思路',
    images: [
      'https://images.unsplash.com/photo-1498837167922-ddd27525d352?w=900&q=80',
      'https://images.unsplash.com/photo-1484723091739-30a097e8f929?w=900&q=80',
      'https://images.unsplash.com/photo-1506084868230-bb9d95c24759?w=900&q=80',
    ],
  },
];

const TOPIC_MAX_LENGTH = 500;
const clampTopic = (value) => String(value || '').slice(0, TOPIC_MAX_LENGTH);

const DEFAULT_XHS_STYLE = SKILL_CATEGORIES?.xiaohongshu?.skills?.[0]?.id || 'xiaohongshu_default';

const CreationPanel = ({ prefillTopic = '', onGenerate: onGenerateExternal, isLoggedIn = false, onLogin }) => {
  const fileInputRef = useRef(null);
  const uploadBoxRef = useRef(null);
  const galleryRef = useRef(null);
  const [activePlatform, setActivePlatform] = useState(() => localStorage.getItem('creation_active_platform') || 'xiaohongshu');
  const [isLoading, setIsLoading] = useState(false);
  const [uploadedImage, setUploadedImage] = useState('');
  const [uploadedImageUrl, setUploadedImageUrl] = useState('');
  const [previewPost, setPreviewPost] = useState(null);
  const [topicLimitExceeded, setTopicLimitExceeded] = useState(false);
  const isReferenceImagePending = Boolean(uploadedImage && !uploadedImageUrl);

  const [params, setParams] = useState({
    topic: '',
    pageCount: 3,
    style: DEFAULT_XHS_STYLE,
  });
  const [isPageDropdownOpen, setIsPageDropdownOpen] = useState(false);

  // Typewriter Effect logic
  const EXAMPLES = useMemo(() => [
    "5分钟学会手冲咖啡，新手第一杯就能拉花，周末在家开个人咖啡馆",
    "入手戴森吸尘器两个月真实测评，和小米比到底值不值得买？优缺点全讲清",
    "云南大理4天3晚穷游攻略，人均1500玩转洱海和苍山，附拍照机位",
    "裸辞后自由职业第100天，从月薪5k到月入2w，我经历了什么",
    "周末遛娃新去处！带孩子做自然探索，3个亲子户外游戏释放电量",
    "平价洗发水红黑榜，油头亲测8款，这3款回购到第5瓶了",
    "副业搞钱指南，AI工具流从选题到出图全流程，个人号也能日更",
    "秋冬通勤穿搭公式，卡其色风衣+贝雷帽，法式慵懒风一周不重样🧥",
  ], []);

  const [exampleIndex, setExampleIndex] = useState(0);
  const [typingText, setTypingText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    // 只有当用户没有输入任何内容时，才运行打字机动画
    if (params.topic.length > 0) return;

    let timer;
    const currentExample = EXAMPLES[exampleIndex];

    if (isDeleting) {
      if (typingText.length > 0) {
        // 删除文字的速度 (较快)
        timer = setTimeout(() => {
          setTypingText(prev => prev.slice(0, -1));
        }, 15);
      } else {
        // 删完了，切换到下一句话，并开始打字
        setIsDeleting(false);
        setExampleIndex((prev) => (prev + 1) % EXAMPLES.length);
      }
    } else {
      if (typingText.length < currentExample.length) {
        // 打字的速度
        timer = setTimeout(() => {
          setTypingText(currentExample.slice(0, typingText.length + 1));
        }, 45); // 稍微放慢打字速度，看清字
      } else {
        // 打完一句话，停顿较长时间让用户阅读，然后开始删除
        timer = setTimeout(() => {
          setIsDeleting(true);
        }, 3000);
      }
    }

    return () => clearTimeout(timer);
  }, [typingText, isDeleting, exampleIndex, EXAMPLES, params.topic]);

  useEffect(() => {
    if (prefillTopic) {
      setTopicLimitExceeded(String(prefillTopic || '').length > TOPIC_MAX_LENGTH);
      setParams((prev) => ({ ...prev, topic: clampTopic(prefillTopic) }));
    }
  }, [prefillTopic]);

  const skillOptions = useMemo(() => {
    const cat = SKILL_CATEGORIES[activePlatform];
    return cat ? cat.skills.map(s => ({ id: s.id, name: s.name, description: s.description })) : [];
  }, [activePlatform]);

  useEffect(() => {
    // 平台切换时，如果当前样式不属于该平台，切换到平台默认
    if (!params.style.startsWith(activePlatform)) {
      const defaultStyle = SKILL_CATEGORIES[activePlatform]?.skills[0]?.id;
      if (defaultStyle) {
        setParams(prev => ({ ...prev, style: defaultStyle }));
        localStorage.setItem('creation_active_style', defaultStyle);
      }
    }
    localStorage.setItem('creation_active_platform', activePlatform);
  }, [activePlatform, params.style]);

  const handleGenerate = () => {
    if (isLoading || isReferenceImagePending) return;
    if (!isLoggedIn) {
      onLogin?.();
      return;
    }
    if (!params.topic) return;
    if (onGenerateExternal) {
      onGenerateExternal({
        topic: params.topic,
        title: params.topic,
        pageCount: params.pageCount,
        style: params.style,
        referenceImageUrl: uploadedImageUrl || '',
      });
    }
  };

  const PLATFORM_THEMES = {
    xiaohongshu: {
      primary: '#FF2442',
      gradient: 'from-[#FF2442] to-[#FF4D6D]',
      shadow: 'shadow-red-100',
      text: 'text-[#FF2442]',
      bg: 'bg-red-50/30'
    },
    wechat: {
      primary: '#07C160',
      gradient: 'from-[#07C160] to-[#10D672]',
      shadow: 'shadow-green-100',
      text: 'text-[#07C160]',
      bg: 'bg-green-50/30'
    },
    product_image: {
      primary: '#8B5CF6',
      gradient: 'from-[#8B5CF6] to-[#A78BFA]',
      shadow: 'shadow-purple-100',
      text: 'text-[#8B5CF6]',
      bg: 'bg-purple-50/30'
    }
  };

  const currentTheme = PLATFORM_THEMES[activePlatform] || PLATFORM_THEMES.xiaohongshu;

  return (
    <div className="animate-fade-in space-y-12 pt-6">
      <div className="mx-auto w-full max-w-5xl px-4 md:px-0">
        <div className="mb-12 text-center">
          <h1 className="text-4xl font-black tracking-tight md:text-[56px] md:leading-tight bg-gradient-to-r from-blue-600 via-purple-500 to-violet-500 bg-clip-text text-transparent">
            让灵感被世界看见
          </h1>
          <p className="mt-3 text-base font-medium text-gray-400 tracking-wide">
            <span className="relative inline-block">
              连接灵感与表达的最后一步
              <span className="absolute -bottom-1.5 left-0 right-0 h-px bg-gradient-to-r from-transparent via-blue-300/40 to-transparent" />
            </span>
          </p>
        </div>

        <div className="bg-white/70 backdrop-blur-2xl rounded-[32px] shadow-[0_20px_50px_rgba(0,0,0,0.05)] border border-white/80 p-6 relative z-10 hover:shadow-[0_30px_60px_rgba(0,0,0,0.08)] transition-all duration-500">
          {/* Top: Upload + Textarea */}
          <div className="flex gap-4 sm:gap-6 mb-4 items-start relative">
            <div className="flex-shrink-0 transition-transform duration-300 hover:scale-[1.02] pt-1 z-10">
              <ImageUploadBox
                ref={uploadBoxRef}
                uploadedImage={uploadedImage}
                setUploadedImage={setUploadedImage}
                setUploadedImageUrl={setUploadedImageUrl}
                isLoggedIn={true}
                onLoginRequired={() => { }}
              />
            </div>

            <div className="flex-1 relative group bg-transparent">
              <textarea
                value={params.topic}
                onChange={(e) => {
                  const val = e.target.value;
                  setTopicLimitExceeded(val.length > TOPIC_MAX_LENGTH);
                  setParams((prev) => ({ ...prev, topic: clampTopic(val) }));
                }}
                onPaste={(e) => {
                  const files = e.clipboardData?.files;
                  if (!files || files.length === 0) return;

                  const imageFile = Array.from(files).find((file) => file.type?.startsWith('image/'));
                  if (!imageFile) return;

                  e.preventDefault();
                  uploadBoxRef.current?.uploadFile?.(imageFile);
                }}
                placeholder={typingText || (params.topic ? '' : '|')}
                className="w-full h-[120px] resize-none outline-none text-gray-800 text-lg placeholder-gray-400/80 bg-transparent leading-relaxed p-0 pt-2 transition-all"
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && !e.shiftKey) {
                    e.preventDefault();
                    handleGenerate();
                  }
                }}
              />
              <div className="absolute top-[90px] left-0 right-0 flex items-center justify-between border-t border-gray-100/30 pt-1 px-0.5">
                <span className={`text-[10px] font-medium transition-colors ${topicLimitExceeded ? 'text-red-500' : 'text-gray-400'}`}>
                  {topicLimitExceeded ? `最多支持 ${TOPIC_MAX_LENGTH} 字，超出部分已自动截断` : `主题最多 ${TOPIC_MAX_LENGTH} 字`}
                </span>
                <span className={`text-[10px] font-medium tabular-nums transition-colors ${params.topic.length >= TOPIC_MAX_LENGTH ? 'text-red-500' : 'text-gray-300'}`}>
                  {params.topic.length} / {TOPIC_MAX_LENGTH}
                </span>
              </div>
            </div>
          </div>

          <div className="w-full h-[1px] bg-gray-100 mb-5" />

          {/* Bottom Toolbar */}
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2 sm:gap-3 flex-wrap">
              {/* Platform Selector */}
              <div className="bg-gray-50/60 hover:bg-gray-50 rounded-2xl transition-colors">
                <PlatformSelector
                  value={activePlatform}
                  onChange={setActivePlatform}
                  label="选择平台"
                  size="small"
                  direction="up"
                />
              </div>

              {/* Style Selector */}
              <div className="bg-gray-50/60 hover:bg-gray-50 rounded-2xl transition-colors">
                <SkillSelector
                  value={params.style}
                  onChange={(s) => {
                    setParams(p => ({ ...p, style: s }));
                    localStorage.setItem('creation_active_style', s);
                  }}
                  options={skillOptions}
                  label="创作风格"
                  size="small"
                  direction="up"
                />
              </div>

              {/* Page Count Selection (Custom UI) */}
              <div className="relative">
                <button
                  onClick={() => setIsPageDropdownOpen(!isPageDropdownOpen)}
                  className="flex items-center gap-1.5 px-3 py-1.5 rounded-2xl bg-gray-50/60 hover:bg-gray-50 transition-colors text-xs font-medium group"
                >
                  <span className="text-gray-400">页数</span>
                  <span className="text-gray-900 font-bold min-w-[12px] text-center">{params.pageCount}</span>
                  <ChevronDown className={`h-3.5 w-3.5 text-gray-400 transition-transform duration-300 ${isPageDropdownOpen ? 'rotate-180' : ''}`} />
                </button>

                {isPageDropdownOpen && (
                  <>
                    <div className="fixed inset-0 z-50" onClick={() => setIsPageDropdownOpen(false)} />
                    <div className="absolute bottom-full mb-2 left-0 z-[60] bg-white/95 backdrop-blur-xl rounded-2xl border border-gray-100 shadow-[0_20px_40px_rgba(0,0,0,0.12)] p-1 min-w-[90px] animate-in fade-in slide-in-from-bottom-2 duration-300">
                      {[1, 3, 5, 7, 9].map((num) => (
                        <button
                          key={num}
                          onClick={() => {
                            setParams(prev => ({ ...prev, pageCount: num }));
                            setIsPageDropdownOpen(false);
                          }}
                          className={`
                            w-full flex items-center justify-between px-3 py-2 rounded-xl text-xs font-bold transition-all
                            ${params.pageCount === num ? 'bg-blue-50 text-[#2563EB]' : 'text-gray-600 hover:bg-gray-50'}
                          `}
                        >
                          <span>{num} 页</span>
                          {params.pageCount === num && <div className="w-1.5 h-1.5 rounded-full bg-[#2563EB]" />}
                        </button>
                      ))}
                    </div>
                  </>
                )}
              </div>
            </div>

            {/* Generate Button (药丸形胶囊按钮) */}
            <button
              onClick={handleGenerate}
              disabled={isLoading || isReferenceImagePending || (isLoggedIn && !params.topic)}
              className={`
                h-10 px-6 rounded-full font-bold text-sm
                flex items-center gap-2 transition-all duration-300 
                relative overflow-hidden group ml-3
                ${isLoading || isReferenceImagePending || (isLoggedIn && !params.topic)
                  ? 'bg-[#F3F4F6] text-gray-400 cursor-not-allowed shadow-none'
                  : 'bg-gradient-to-r from-blue-600 via-indigo-500 to-indigo-600 text-white shadow-[0_4px_14px_rgba(99,102,241,0.3)] hover:shadow-[0_6px_20px_rgba(99,102,241,0.4)] hover:-translate-y-[1px] active:translate-y-0 active:scale-[0.98]'
                }
              `}
            >
              {isLoading ? (
                <>
                  <Loader2 className="h-4 w-4 animate-spin" />
                  <span>生成中...</span>
                </>
              ) : isReferenceImagePending ? (
                <>
                  <Loader2 className="h-4 w-4 animate-spin" />
                  <span>上传中...</span>
                </>
              ) : !isLoggedIn ? (
                // 状态1: 未登录时：蓝色渐变，文字“登录并生成”
                <span className="tracking-wide">登录并生成</span>
              ) : (
                // 状态2: 已登录时：根据有无内容切换颜色。积分精小且融合显示。
                <>
                  <span className="tracking-wide">生成</span>
                  <div className={`flex items-center mt-[1px] transition-opacity ${!params.topic ? 'text-gray-400 opacity-60' : 'text-yellow-300/90'}`}>
                    <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                    <span className={`font-black text-[11px] ml-0.5 ${!params.topic ? 'text-gray-400' : 'text-white/95'} leading-none`}>
                      {(params.pageCount || 1) * 7}
                    </span>
                  </div>
                </>
              )}
              {/* Shine effect */}
              {!isLoading && (!isLoggedIn || params.topic) && (
                <div className="absolute top-0 -inset-full h-full w-1/2 z-5 block transform -skew-x-12 bg-gradient-to-r from-transparent to-white opacity-20 group-hover:animate-shine" />
              )}
            </button>
          </div>
        </div>


      </div>

      {/* Curated Gallery */}
      <div className="mt-16 mx-auto max-w-5xl pb-6">
        <h3 className="text-lg font-bold text-gray-900 mb-1 flex items-center px-1">
          <svg className="w-5 h-5 text-yellow-500 mr-2" viewBox="0 0 24 24" fill="currentColor"><path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" /></svg>
          热门精选
        </h3>
        <div className="relative group/gallery overflow-hidden">
          <div
            ref={galleryRef}
            className="flex overflow-x-auto pb-6 gap-3 px-1 snap-x snap-mandatory"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          >
            {curatedPosts.map((post) => (
              <div
                key={post.id}
                className="flex-shrink-0 aspect-[3/4] bg-gray-900 rounded-2xl overflow-hidden relative group cursor-pointer shadow-sm hover:shadow-xl transition-all hover:-translate-y-1 snap-start"
                style={{ width: 'calc((100% - 36px) / 4)' }}
                onClick={() => setPreviewPost(post)}
              >
                <img src={post.image} alt={post.title} className="absolute inset-0 w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent flex flex-col justify-end p-4">
                  <p className="text-white text-sm font-bold line-clamp-1 mb-1 drop-shadow-md">{post.title}</p>
                  <p className="text-gray-300 text-[11px] font-medium line-clamp-2 leading-tight opacity-90">{post.desc}</p>
                  <p className="text-gray-200 text-[10px] mt-2">作者 @{post.author}</p>
                </div>
              </div>
            ))}
          </div>
          {/* Left Arrow */}
          <button
            onClick={() => galleryRef.current?.scrollBy({ left: -(galleryRef.current?.offsetWidth || 300), behavior: 'smooth' })}
            className="absolute left-0 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white shadow-lg rounded-full p-2 z-10 opacity-0 group-hover/gallery:opacity-100 transition-opacity duration-300 ml-1"
          >
            <svg className="w-5 h-5 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
          </button>
          {/* Right Arrow */}
          <button
            onClick={() => galleryRef.current?.scrollBy({ left: galleryRef.current?.offsetWidth || 300, behavior: 'smooth' })}
            className="absolute right-0 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white shadow-lg rounded-full p-2 z-10 opacity-0 group-hover/gallery:opacity-100 transition-opacity duration-300 mr-1"
          >
            <svg className="w-5 h-5 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
          </button>
        </div>
      </div>

      {/* Footer */}
      <div className="mt-12 pb-8 text-center text-xs text-gray-300 space-y-1">
        <p>Copyright ? 2025 ContentOS Pro. All rights reserved.</p>
        <div className="flex items-center justify-center gap-2">
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs text-gray-400 hover:text-gray-600 transition-colors"
          >
            {'\u9ed4ICP\u59072025060431\u53f7-1'}
          </a>
          <span className="text-xs text-gray-400">|</span>
          <a
            href="https://beian.mps.gov.cn/#/query/webSearch?code=52019002007461"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1 text-xs text-gray-400 hover:text-gray-600 transition-colors"
          >
            <img src="/wabeian.png" alt={'\u516c\u5b89\u7f51\u5907'} className="w-4 h-4" />
            <span>{'\u8d35\u516c\u7f51\u5b89\u590752019002007461\u53f7'}</span>
          </a>
        </div>
      </div>

      <ContentPreviewModal
        open={Boolean(previewPost)}
        onClose={() => setPreviewPost(null)}
        title={previewPost?.title || ''}
        plainText={previewPost?.content || previewPost?.desc || ''}
        channel="xiaohongshu"
        images={previewPost?.images || (previewPost?.image ? [previewPost.image] : [])}
        authorName={previewPost?.author || 'ContentOS'}
      />
    </div>
  );
};

export default CreationPanel;

